﻿// TikTok Pixel & Events API Tracker
export const trackTikTokEvent = (
  eventName: string,
  properties: Record<string, any> = {},
  userData?: { email?: string; phone?: string; external_id?: string }
) => {
  try {
    // 1. Browser-side tracking (TikTok Pixel)
    if (typeof window !== 'undefined' && (window as any).ttq) {
      (window as any).ttq.track(eventName, properties);
    }

    // 2. Server-side tracking (Events API via Cloudflare Pages Function)
    fetch('/api/tiktok-event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: eventName,
        properties,
        user: userData || {},
      }),
    }).catch((err) => {
      console.debug('[TikTok Events API] dispatch error:', err);
    });
  } catch (e) {
    console.warn('[TikTok] Tracking error:', e);
  }
};
